import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CreditCardOutlined } from '@ant-design/icons';

// DS
import {
  Col,
  VertTypography,
  VertIcon,
  Row,
  VertRadio,
  VertButton,
  VertSkeleton,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/CheckoutPaymentStyles.less';
import PaymentScoreMoreMoney from './PaymentScoreMoreMoney/PaymentScoreMoreMoney';
import PipeProvider from 'Services/Providers/PipeProvider';
import { useSelector } from 'react-redux';
import ynToBool from 'Utils/ynToBool';
import { convertBalance } from 'Utils/convertPoints';
import { balanceUser } from 'structure/header/BalanceUser';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import generateUUID from 'Utils/generateUUID';
import { PaymentSummary } from './PaymentScoreMoreMoney/PaymentSummary';
import { handleObjectAddress } from 'Utils/handleObjectAddress';
import CreateBraspagInput from 'Shared/Widgets/BraspagDebit/CreateBraspagInput';
import BraspagAuthorize from 'Shared/Widgets/BraspagDebit/braspag-debit';
import { useNavigate } from 'react-router';
import { pointsMask } from 'Utils/commons/points';
import {useCheckoutProvider} from "../CheckoutProvider";
import useGA from "Utils/Ga";
import getNameOfVendor from "Utils/getNameOfVendor";
import { currencyMask } from 'Utils/commons/cash';


// UTILS

const methodPayments = [
  { label: 'Usar apenas pontos', value: 'pontos' },
  { label: 'Usar pontos + dinheiro', value: 'dinheiro' },
];

// CHECKOUT PERSONAL DATA COMPONENT
const CheckoutPayment = ({ ...props }) => {
  const {
    handlePaymentsInfos,
    createOrderActive,
    setCreateOrderActive,
    onBraspagError,
  } = props;
  const { eventGaUnlimited } = useGA()

  const { setCredicard } = useCheckoutProvider()
  const Stores = useSelector(({ Stores }) => Stores)
  /* HOOKS */
  const [methodPaymentsActives, setMethodsPaymentActives] =
    useState(methodPayments);
  const [isLoadingBraspagInput, setIsLoadingBraspagInput] = useState(true);
  const [aliasGenerated, setAlias] = useState(null);
  const [paymentBraspag, setPaymentBraspag] = useState({
    authorized: false,
    authorizationInfos: null,
  });
  const [braspagErroInfo, setBraspagErrorInfo] = useState({
    braspagErrorInfo: null,
  });
  const [
    isLoadingBraspagConfirmationModal,
    setIsLoadingBraspagConfirmationModal,
  ] = useState({ isLoadingBraspagConfirmationModal: null });

  const [methodPayment, setMethodPayment] = useState(null);

  const initialStateCheckoutInfos = {
    cardBrandId: null,
    cardHolderName: null,
    cardHolderCPF: null,
    cardNumber: null,
    expirationMonth: null,
    expirationYear: null,
    securityCode: null,
    installments: null,
    installmentValue: null,
    pointsValue: null,
    pointsSelected: null,
    cashSelected: null,
    methodPayment: null,
    isValid: false,
  };
  const [checkoutInfos, setCheckoutInfos] = useState({
    ...initialStateCheckoutInfos,
  });
  const [incompletePurchase, setIncompletePurchase] = useState(true);

  const [customer, setCustomer] = useState({
    emailUser: '',
    nameUser: '',
    phoneUser: '',
  });
  const [billingAddress, setBillingAddress] = useState({
    street: '',
    complement: '',
    city: '',
    state: '',
    zipCode: '',
  });

  /* REDUCERS */
  const PaymentConfig = useSelector(({ PaymentConfig: data }) => data);

  const PaymentInstallments = useSelector(
    ({ PaymentInstallments: data }) => data
  );
  const { paymentConfig: PointsAndCashConfig } = PaymentConfig;

  const Balance = useSelector(({ Balance: data }) => data);
  const { pointsValue } = Balance;

  const Cart = useSelector(({ Cart: data }) => data);
  const { coupon } = Cart;

  const Catalog = useSelector(({ Catalog: data }) => data);
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;
  const totalDiscount = coupon?.discountValue || 0;
  const ShippingCart = useSelector(({ Shipping: data }) => data);

  

  const isErrorShipping = ShippingCart?.hasError;

  const Participants = useSelector(({ Participants: data }) => data);

  const CreatePurchase = useSelector(({ CreatePurchase: data }) => data);

  const { callApi } = usePipeContext();
  const navigate = useNavigate();

  const gaSetMethodPayment = (method) => {
    const itemsCartReducer = Cart
    eventGaUnlimited("add_payment_info", {
      currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
      payment_type: method === 'dinheiro' ? "Credit Card": 'Points',
      value: parseFloat(itemsCartReducer?.cart?.price),
      items: itemsCartReducer?.cart?.items.map(({ vendor, sku, name, price, quantity, category }) => ({
        item_id: sku,
        item_name: name,
        currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
        item_brand: getNameOfVendor(vendor.id, vendor.type, Stores)?.name,
        item_category: category.name,
        price: parseFloat(price),
        quantity
      }))
    })
  }

  /* HANDLES */
  const handleCheckoutInfos = (infos) => {
    //PEGA INFORMAÇÕES DE CHECKOUT
    setCheckoutInfos({
      ...checkoutInfos,
      ...infos,
    });
  };
  const resetCheckoutInfos = () => {
    // RESETA APÓS O USO
    // Segurança, para evitar que as infos de checkout do usuário fiquem em um contexto
    setCheckoutInfos({ ...initialStateCheckoutInfos });
  };

  const handleSelectedMethod = (method) => {
    gaSetMethodPayment(method);
    setMethodPayment(method); //SELECIONAR FORMA DE PAGAMENTO
  };
  const handleIsLoadingBraspagInput = (status) => {
    setIsLoadingBraspagInput(status);
  };

  const handleBalance = ({ points, currency, hideCurrency }) => {
    return `${points}${hideCurrency ? '' : ` ${currency}`}`; // EXIBIR PONTUAÇÃO NO FORMATO DA CAMPANHA
  };

  const removeMethodPayments = (valueToRemove, shouldExclude) => {
    const updatedMethodPayments = methodPaymentsActives.map((item) => {
      if (item.value === valueToRemove) {
        return shouldExclude ? [] : { ...item, disabled: true };
      }
      return item;
    });
    return updatedMethodPayments.filter(
      (item) => item !== null && item.length !== 0
    );
  };

  const handlePurchaseDebit = (braspagAuthenticationInfos) => {
    setPaymentBraspag({
      authorized: true,
      authorizationInfos: braspagAuthenticationInfos,
    });
  };
  const handleShowBraspagError = (error) => {
    setBraspagErrorInfo({ braspagErrorInfo: error });
  };
  const handleIsLoadingBraspagConfirmationModal = (value) => {
    setIsLoadingBraspagConfirmationModal({
      isLoadingBraspagConfirmationModal: value,
    });
  };

  useEffect(() => {
    if (createOrderActive) {
      createOrder();
    }
  }, [createOrderActive]);

  useEffect(() => {
    if (paymentBraspag.authorized) {
      createOrder();
    }
  }, [paymentBraspag]);

  const createOrder = () => {
    // MONTA CHAMADA DA COMPRA
    if (methodPayment === 'pontos') {
      createPurchase();
    }
    if (methodPayment === 'dinheiro') {
      if (checkoutInfos?.isValid && checkoutInfos?.methodPayment === 'debito') {
        if (paymentBraspag.authorized) {
          createPurchase({
            ...checkoutInfos,
            isDebit: true,
            cardCavv: paymentBraspag?.authorizationInfos.cavv,
            cardXid: paymentBraspag?.authorizationInfos.xid,
            cardEci: paymentBraspag?.authorizationInfos.eci,
            cardVersion: paymentBraspag?.authorizationInfos.version,
            cardReferenceID: paymentBraspag?.authorizationInfos.referenceId,
          });
          setCredicard({
            ...checkoutInfos,
            isDebit: true,
            cardCavv: paymentBraspag?.authorizationInfos.cavv,
            cardXid: paymentBraspag?.authorizationInfos.xid,
            cardEci: paymentBraspag?.authorizationInfos.eci,
            cardVersion: paymentBraspag?.authorizationInfos.version,
            cardReferenceID: paymentBraspag?.authorizationInfos.referenceId,
          });
        } else {
          handleSendAuthenticate();
        }
      } else {
        setCredicard(checkoutInfos);
        createPurchase(checkoutInfos);
      }
    }
  };
  const createPurchase = (payload) => {
    // EFETIVA A COMPRA
    callApi({
      symbol: 'FETCH_CREATE_PURCHASE',
      alias: generateUUID(),
      payload: payload,
    });
  };
  const handlePointsCashConfig = () => {
    callApi({
      symbol: 'FETCH_POINTS_CASH_CONFIG',
      alias: generateUUID(),
    });
  };

  const SetInfosToShow = useCallback(() => {
    const { cart } = Cart;
    const { value } = ShippingCart;
    const { paymentInstallments } = PaymentInstallments;

    const total =
      (paymentInstallments &&
        paymentInstallments.filter(({ parcel }) => parcel === 1)[0]) ||
      null;
    switch (methodPayment) {
      case 'dinheiro':
        handleCheckoutInfos({
          ...checkoutInfos,
          cashSelected: total ? total.parcelValue : 0,
        });
        break;
      default:
        handleCheckoutInfos({
          ...checkoutInfos,
          pointsSelected: (cart.price || 0) + (value.total || 0) || 0,
          cashSelected: null,
        });
    }
  }, [checkoutInfos, methodPayment, Cart, ShippingCart, PaymentInstallments]);

  const handleSendAuthenticate = () => {
    /* eslint-disable */
    if (window && typeof window.sendAuthenticate === 'function') {
      window.sendAuthenticate();
    }
    /* eslint-enable */
  };

  const handleSetPurchaseEventGA = useCallback((id) => {
    const eventData = {
      event: "purchase",
      payment_type: methodPayment,
      ecommerce: {
        transaction_id: id,
        value: parseFloat(Cart?.cart?.price),
        tax: 0,
        shipping: parseFloat(ShippingCart?.value?.total),
        currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
        items: Cart?.cart?.items.map(({ sku, name, category, quantity, price, vendor }) => ({
          item_id: sku,
          item_name: name,
          currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
          item_brand: getNameOfVendor(vendor.id, vendor.type, Stores)?.name,
          item_category: category?.name,
          price: parseFloat(price),
          quantity
        }))
      }
    }

    const { ecommerce, ...scorn } = eventData;
    eventGaUnlimited(scorn, ecommerce);
  }, [ Cart, ShippingCart])

  useEffect(() => {
    if (braspagErroInfo && braspagErroInfo.braspagErrorInfo) {
      onBraspagError(braspagErroInfo.braspagErrorInfo);
    }
  }, [braspagErroInfo]);

  /* LIFE CYCLES */

  useEffect(() => {
    if (
      CreatePurchase?.finishRequests &&
      !CreatePurchase?.isError &&
      CreatePurchase?.status !== 406 &&
      CreatePurchase?.status !== 'RequiresTokenValidation' &&
      CreatePurchase?.status !== 'MessageOnBoardingRequired'
    ) {
      handleSetPurchaseEventGA(CreatePurchase.createPurchase.id)
      navigate(
        `/order-details?orderId=${CreatePurchase.createPurchase.id}&fromCheckout=true`
      );
    }
  }, [CreatePurchase?.finishRequests]);

  useEffect(() => {
    if (checkoutInfos?.isValid) {
      setIncompletePurchase(false);
      handlePaymentsInfos({
        isValid: true,
        installments: checkoutInfos.installments,
        installmentValue: checkoutInfos.installmentValue,
        pointsValue: checkoutInfos.pointsValue,
        pointsSelected: checkoutInfos.pointsSelected,
        cashSelected: currencyMask(checkoutInfos.cashSelected),
      });
    } else {
      if (methodPayment !== 'pontos') {
        setIncompletePurchase(true); //DESABILITAR BOTÃO PARA PROSSEGUIR
        handlePaymentsInfos({
          isValid: false,
        });
        setCreateOrderActive(false);
      }
    }
  }, [checkoutInfos]);

  useEffect(() => {
    SetInfosToShow();


    handlePointsCashConfig();
    if (methodPayment === 'pontos') {
      setIncompletePurchase(false);
      handlePaymentsInfos({
        isValid: true,
      });
    } else if (methodPayment === 'dinheiro') {
      handleCheckoutInfos({
        pointsSelected: 0,
      });
    }
  }, [methodPayment]);

  useEffect(() => {
    if (
      PaymentInstallments.paymentInstallments &&
      PaymentInstallments.paymentInstallments.length
    ) {
      SetInfosToShow();
    }
  }, [PaymentInstallments]);

  useEffect(() => {
    const { paymentConfig: PointsAndCashConfigNow } = PaymentConfig;
    if (
      PaymentConfig?.finishRequests &&
      PointsAndCashConfigNow?.isAbilityInCampaing &&
      !PointsAndCashConfigNow?.isExecutePointAndCash
    ) {
      const updatedMethodPayments = removeMethodPayments(`dinheiro`);
      setMethodsPaymentActives(updatedMethodPayments);
    }
    if (
      PaymentConfig?.finishRequests &&
      !PointsAndCashConfigNow?.isAbilityInCampaing
    ) {
      const updatedMethodPayments = removeMethodPayments(`dinheiro`, true);
      setMethodsPaymentActives(updatedMethodPayments);
    }
  }, [PaymentConfig?.finishRequests, PaymentConfig]);

  //Em caso de erro na api de points + cash, desabilitamos a forma de pagamento
  useEffect(() => {
    if (ynToBool(PaymentConfig?.isError)) {
      const updatedMethodPayments = removeMethodPayments(`dinheiro`);
      setMethodsPaymentActives(updatedMethodPayments);
      setCreateOrderActive(false);
    }
  }, [PaymentConfig?.isError]);

  // sempre iniciar a página com campos vazios
  useEffect(() => {
    resetCheckoutInfos();
    setAlias(generateUUID());
  }, []);



  useEffect(() => {
    if (
      Cart?.cartFinishRequests &&
      ShippingCart?.finishRequests &&
      !ShippingCart?.isError
    ) {
      const { value } = ShippingCart;
      const totalShipping = value?.total;

      const { cart } = Cart;
      const totalCart = cart?.price;

      const totalPoints = Math.max(totalCart + (totalShipping || 0) - totalDiscount,0);

      if(totalPoints == 0) {
        const updatedMethodPayments = removeMethodPayments(`dinheiro`);
        setMethodsPaymentActives(updatedMethodPayments);
        return;
      }

      // usei negativa, pois o intuito é saber se o total da compra é MENOR que a pontuação do usuário.
      if (!(pointsValue >= totalPoints)) {
        const updatedMethodPayments = removeMethodPayments(`pontos`);
        setMethodsPaymentActives(updatedMethodPayments);
      }
    }
  }, [Cart?.cartFinishRequests, ShippingCart?.finishRequests, totalDiscount]);

  useEffect(() => {
    if (Participants?.finishRequests && !Participants?.isError) {
      const emailUser = Participants?.email?.value || '';
      const nameUser = Participants?.name?.value || '';
      const phoneUser =
        `${Participants?.phone?.areaCode} ${Participants?.phone?.number}` || '';

      setCustomer({
        emailUser: emailUser,
        nameUser: nameUser,
        phoneUser: phoneUser,
      });
    }
  }, [Participants?.finishRequests]);

  useEffect(() => {
    if (Cart?.cartFinishRequests && Participants?.finishRequests) {
      const result = handleObjectAddress(Cart, Participants);
      setBillingAddress({
        street: result?.street?.value,
        complement: result?.complement?.value,
        city: result?.city?.value,
        state: result?.state?.value,
        zipCode: result?.zipCode?.value,
      });
    }
  }, [Cart?.cartFinishRequests, Participants?.finishRequests]);

  const balanceLabel = handleBalance({
    ...convertBalance(pointsValue, decimalPlaces, pointsName),
    hideCurrency: false,
  });

  /* VARIAVEIS */
  let isLoading = CreatePurchase?.isLoading;

    


  return (
    <PipeProvider
      apiSymbols={[
        'LOAD_BALANCE',
        'FETCH_CART',
        {
          symbol: 'FETCH_POINTS_CASH_CONFIG',
          alias: aliasGenerated,
          payload: {},
        },
      ]}
      loadingComponent={
        <VertSkeleton paragraph={{ rows: 4 }} active title={false} />
      }
    >
      <Col className="checkout-payment-wrapper col-12 col-md-auto">
        <Col className="checkout-payment-title">
          <VertIcon component={CreditCardOutlined} />
          <VertTypography.Title>Pagamento</VertTypography.Title>
        </Col>
        <Col className="checkout-payment-content">
          <Row>
            <VertTypography.Paragraph>
              Escolha como resgatar sua compra.
              {!ynToBool(process.env.REACT_APP_HIDE_CARD_COMPLEMENT_PAYMENT_TEXT)
                && "Você pode usar apenas pontos ou, se preferir, também pode pagar com pontos e dinheiro (cartão de crédito)."
              }
            </VertTypography.Paragraph>
          </Row>
          <Row>
            <VertTypography.Paragraph strong>
              Seu saldo:
              {` ${pointsMask(pointsValue, decimalPlaces, pointsName).value} ${
                pointsMask(pointsValue, decimalPlaces, pointsName).label
              }` || '-'}
            </VertTypography.Paragraph>
          </Row>
          <Row className="box-method-payment">
            <VertRadio.Group
              options={methodPaymentsActives}
              buttonStyle="solid"
              onChange={({ target }) => handleSelectedMethod(target.value)}
              value={methodPayment}
              disabled={isErrorShipping}
              template="marketplace"
              size="small"
              optionType="default"
            />
          </Row>
          <hr className="divider" />

          {methodPayment === 'dinheiro' ? (
            //pointsValue: pontuação do usuário logado
            <PaymentScoreMoreMoney
              pointsValue={pointsValue}
              handleCheckoutInfos={handleCheckoutInfos}
            />
          ) : (
            ''
          )}
          {methodPayment && (
            <Row className="checkout-payment-value">
              <PaymentSummary
                methodPayment={methodPayment}
                isLoading={isLoading}
                disabled={incompletePurchase}
                createOrder={createOrder}
                cashSelected={checkoutInfos?.cashSelected}
                pointsSelected={checkoutInfos?.pointsSelected}
              />
            </Row>
          )}
          {
            //Nessa etapa o usuário terminou de digitar os dados do cartão
            checkoutInfos?.methodPayment === 'debito' ? (
              <CreateBraspagInput
                customer={{
                  name: customer?.nameUser,
                  email: customer?.emailUser,
                  phone: customer?.phoneUser,
                }}
                billingAddress={{
                  street: billingAddress?.street,
                  complement: billingAddress?.complement,
                  city: billingAddress?.city,
                  state: billingAddress?.state,
                  zipCode: billingAddress?.zipCode,
                }}
                debitCard={{
                  cardHolderCPF: checkoutInfos?.cardHolderCPF,
                  cardBrandId: checkoutInfos?.cardBrandId,
                  validityDate: `${checkoutInfos?.expirationMonth}/${checkoutInfos?.expirationYear}`,
                  number: checkoutInfos?.cardNumber,
                }}
                paymentPoints={checkoutInfos?.installmentValue}
                setIsLoadingBraspagInput={handleIsLoadingBraspagInput}
                handlePurchaseDebit={handlePurchaseDebit}
                handleShowError={handleShowBraspagError}
                setIsLoadingBraspagConfirmationModal={
                  handleIsLoadingBraspagConfirmationModal
                }
              />
            ) : null
          }
          {/* Adicionar os scripts SÓ depois de adicionar o inputs */}
          {checkoutInfos?.methodPayment === 'debito' &&
            !isLoadingBraspagInput && <BraspagAuthorize />}
        </Col>
      </Col>
    </PipeProvider>
  );
};

CheckoutPayment.propTypes = {
  handlePaymentsInfos: PropTypes.func,
  createOrderActive: PropTypes.bool,
  setCreateOrderActive: PropTypes.func,
  onBraspagError: PropTypes.func,
};

export default CheckoutPayment;
